import * as React from "react";
import { Callout } from "@octopusdeploy/design-system-components";
import ExternalLink from "components/Navigation/ExternalLink/ExternalLink";

export function AreYouSureYouWantToIncreaseTheLimitCallout() {
    return <Callout type="warning" title="Limits">
        <p>
            We increase customer's limits only when there is no way for them to reduce their usage and stay within or close to <ExternalLink href="https://octopus.com/legal/acceptable-usage">the specified limits</ExternalLink>.
        </p>

        <p>
            The following questions should help you make the right decision.

            Increase the limit only when you can answer <strong>Yes</strong> to all questions:
        </p>

        <p>
            - Have you worked with the customer to try to reduce their usage?
        </p>
        <p>
            - Is the new limit going to solve the customer's problem permanently? Customers needing ever increasing resource limits might not be a good fit for Octopus Cloud.
        </p>

        If you are not sure how to answer the questions then please reach out to <a rel="noopener" target="_blank" href="https://octopusdeploy.slack.com/archives/C01Q95KPRM4">#cloud-platform-requests</a> for help.

    </Callout>;
}

export function ManualScalingCallout() {
    return <Callout type="information" title="Manual Scaling">
        <p>
            When manually scaling an Instance please ensure you:<br/>
            - Consider disabling automatic scaling<br/>
            - Reach out to <ExternalLink href={"https://octopusdeploy.slack.com/archives/C01Q95KPRM4"}>#cloud-platform-requests</ExternalLink> to tell us what's happening<br/>
            - Fill out <ExternalLink href={"https://docs.google.com/spreadsheets/d/1SgpASOAUXT35FUmyuzzx0lfBW7m2TD1fe9JPno_WTyg/edit?usp=sharing"}>the spreadsheet</ExternalLink> to document what Instances are scaled manually.
        </p>
    </Callout>;
}
